export default __webpack_public_path__ + "8abc7652e7bd9f981f12eaaad18a9dbf.png";